import { EDUCATOR_ROLE, STUDENT_ROLE } from '@core/constants/space';

export type HomeViewRole = typeof EDUCATOR_ROLE | typeof STUDENT_ROLE;

export const HOME_VIEW_ROLES: HomeViewRole[] = [EDUCATOR_ROLE, STUDENT_ROLE];

export const HOME_VIEW_ROLE_LABELS: Record<HomeViewRole, string> = {
  [EDUCATOR_ROLE]: 'Educator',
  [STUDENT_ROLE]: 'Student',
};
